import { rpc } from './rpc';

/**
 * Profile pictures are loaded in batches: all avatars requested in the same moment
 * go out as one call. Results are cached per person and version (upload time).
 */

const cache = new Map<string, Promise<string | null>>();
let queue = new Map<string, { resolve: (v: string | null) => void; reject: (e: unknown) => void }[]>();
let timer: ReturnType<typeof setTimeout> | null = null;

function flush() {
  timer = null;
  const batch = queue;
  queue = new Map();
  const ids = [...batch.keys()];
  rpc('avatars.get', { ids })
    .then((r) => {
      for (const id of ids) for (const w of batch.get(id) ?? []) w.resolve(r.avatars[id] ?? null);
    })
    .catch((e) => {
      for (const id of ids) for (const w of batch.get(id) ?? []) w.reject(e);
    });
}

export function loadAvatar(personId: string, version: string): Promise<string | null> {
  const key = `${personId}:${version}`;
  const hit = cache.get(key);
  if (hit) return hit;
  const p = new Promise<string | null>((resolve, reject) => {
    const list = queue.get(personId) ?? [];
    list.push({ resolve, reject });
    queue.set(personId, list);
    if (!timer) timer = setTimeout(flush, 30);
  });
  cache.set(key, p);
  p.catch(() => cache.delete(key));
  return p;
}
